import { useFormik } from "formik";
import { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Col,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Progress,
  Spinner,
} from "reactstrap";
import * as Yup from "yup";
import AdsApi from "api/adsApi";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import { NOTI_SETTING_TYPE_OPTION } from "helpers/constans";
import { Radio } from "antd";

export default function CreateEditAdsPlan({
  setIsOpen,
  item,
  setItemToEdit,
  loadTableData,
}: any) {
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  useState<boolean>(false);
  const [normalType, setNormalType] = useState<any>("limited");

  const isEdit = item;

  const handleSubmit = async (values: any) => {
    try {
      setIsLoading((_prev) => true);
      const data = values;
      console.log(data)

      const response: any = await AdsApi?.putPlan(item?.id, data);
      if (response?.data) {
        loadTableData();
        setIsLoading((_prev) => false);
        setIsOpen(false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        setIsLoading(false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsLoading(false);
      toast(`Please re-check your data`);
      return error;
    }
  };

  const validationSchema = Yup.object({});

  const formik = useFormik({
    initialValues: {
      name: "",
      description: "",
      pricing_model: "",
      monthly_fee: 0,
      cost_per_click: 0,
      free_per_month: 0,
      default_budget: 0
    },
    validationSchema,
    onSubmit: handleSubmit,
  });

  useEffect(() => {
    if (item) {
      formik.setFieldValue("name", item?.name);
      formik.setFieldValue("description", item?.description);
      formik.setFieldValue("pricing_model", item?.pricing_model);
      formik.setFieldValue("monthly_fee", item?.monthly_fee);
      formik.setFieldValue("cost_per_click", item?.cost_per_click);
      formik.setFieldValue("free_per_month", item?.free_per_month);
      formik.setFieldValue("default_budget", item?.default_budget);
      setNormalType(item?.pricing_model)
    }
  }, [item]);

  const onCloseClick = () => {
    setIsOpen(false);
    setItemToEdit(false);
  };

  const TYPE_OPTION_LANG =
    NOTI_SETTING_TYPE_OPTION?.map((item: any) => ({
      value: item?.value,
      label: t(item?.label),
    })) || [];

  return (
    <Modal isOpen={true} centered={true} scrollable={false} size="lg">
      <ModalHeader toggle={isLoading ? () => {} : onCloseClick}>
        {/* {isEdit ? t("Update") : t("Create")} */}
        {
          TYPE_OPTION_LANG?.find(
            (i: any) => String(i?.value) === String(item?.type)
          )?.label
        }
      </ModalHeader>
      <ModalBody className="py-3 px-4">
        <div className="mb-4">
          <Progress
            value={100 - (100 / 2) * Number(Object.keys(formik.errors).length)}
            color="primary"
            className="animated-progress progress-sm"
          />
        </div>
        <form onSubmit={formik.handleSubmit}>
          <div className="row g-3">
            <Col xxl={12}>
              <label className="form-label">
                {t("Package Name")}
                {/* <span className="text-danger"> *</span> */}
              </label>
              <Input
                name="name"
                type="text"
                className="form-control"
                id="name"
                placeholder={`${t("Package Name")}...`}
                value={formik?.values?.name}
                onChange={(event: any) =>
                  formik.setFieldValue(
                    "name",
                    event?.target?.value
                  )
                }
              />
            </Col>
            <Col lg={12}>
              <label htmlFor="subheadInputKorea" className="form-label">
                {t("Pricing Model")}
              </label>

              <div className="d-block mb-2">
                <Radio.Group
                  onChange={(e) => {
                    formik.setFieldValue('pricing_model', e?.target?.value);
                  }}
                  value={formik?.values?.pricing_model}
                >
                  <Radio value={"Monthly"}>{t("Monthly")}</Radio>
                  <Radio value={"unlimited"}>{t("Unlimited")}</Radio>
                </Radio.Group>
              </div>
              {/* {normalType == "monthly" && (
                <Input
                  name="numberOfPushForNormalUser"
                  type="text"
                  className="form-control"
                  id="numberOfPushForNormalUser"
                  placeholder={t("Standard User Push Count")}
                  value={formik?.values?.numberOfPushForNormalUser}
                  onChange={(event: any) =>
                    formik.setFieldValue(
                      "numberOfPushForNormalUser",
                      event?.target?.value
                    )
                  }
                />
              )} */}
            </Col>{" "}
            <Col xxl={6}>
              <label className="form-label">
                {t("Monthly Fee")}
                {/* <span className="text-danger"> *</span> */}
              </label>
              <Input
                name="monthly_fee"
                type="text"
                className="form-control"
                id="monthly_fee"
                placeholder={`${t("Monthly Fee")}...`}
                value={formik?.values?.monthly_fee}
                onChange={(event: any) =>
                  formik.setFieldValue(
                    "monthly_fee",
                    event?.target?.value
                  )
                }
              />
            </Col>
            <Col xxl={6}>
              <label className="form-label">
                {t("Cost Per Click")}
                {/* <span className="text-danger"> *</span> */}
              </label>
              <Input
                name="cost_per_click"
                type="text"
                className="form-control"
                id="cost_per_click"
                placeholder={`${t("Cost Per Click")}...`}
                value={formik?.values?.cost_per_click}
                onChange={(event: any) =>
                  formik.setFieldValue(
                    "cost_per_click",
                    event?.target?.value
                  )
                }
              />
            </Col>
            <Col xxl={6}>
              <label className="form-label">
                {t("Free Period Months")}
                {/* <span className="text-danger"> *</span> */}
              </label>
              <Input
                name="free_per_month"
                type="text"
                className="form-control"
                id="free_per_month"
                placeholder={`${t("Free Period Months")}...`}
                value={formik?.values?.free_per_month}
                onChange={(event: any) =>
                  formik.setFieldValue(
                    "free_per_month",
                    event?.target?.value
                  )
                }
              />
            </Col>
            <Col xxl={6}>
              <label className="form-label">
                {t("Default Budget")}
                {/* <span className="text-danger"> *</span> */}
              </label>
              <Input
                name="default_budget"
                type="text"
                className="form-control"
                id="default_budget"
                placeholder={`${t("Default Budget")}...`}
                value={formik?.values?.default_budget}
                onChange={(event: any) =>
                  formik.setFieldValue(
                    "default_budget",
                    event?.target?.value
                  )
                }
              />
            </Col>
            <Col xxl={12}>
              <label className="form-label">
                {t("Description")}
                {/* <span className="text-danger"> *</span> */}
              </label>
              <textarea
                className="form-control"
                id="description"
                name="description"
                value={formik?.values?.description}
                placeholder={`${t("Description")}...`}
                onChange={(event: any) =>
                  formik.setFieldValue(
                    "description",
                    event?.target?.value || ""
                  )
                }
                style={{ height: 80 }}
              />
            </Col>

            <div className="col-lg-12 mt-4">
              <div className="hstack gap-2 justify-content-end">
                <button
                  className="btn btn-primary fs-14"
                  color="success"
                  type="submit"
                  disabled={isLoading}
                  style={{ width: "120px" }}
                >
                  {isLoading ? (
                    <Spinner size="sm" className="me-2"></Spinner>
                  ) : (
                    <>{isEdit ? t("Button Update") : t("Button Create")}</>
                  )}
                </button>
                <button
                  className="btn btn-secondary fs-14"
                  color="light"
                  type="button"
                  onClick={onCloseClick}
                  disabled={isLoading}
                  style={{ width: "100px" }}
                >
                  {t("Button Close")}
                </button>
              </div>
            </div>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
}
